/* Progressive enhancement for the new native Prendas disclosure only. */
(function () { 'use strict';
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mh10-nav-prendas[open]').forEach(function (node) { node.open = false; node.querySelector('summary').focus(); });
    if (document.getElementById('navMobile')?.classList.contains('open') && typeof window.closeMobileMenu === 'function') { window.closeMobileMenu(); document.getElementById('navBurger')?.focus(); }
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.mh10-nav-prendas[open]').forEach(function (node) { if (!node.contains(event.target)) node.open = false; });
    if (event.target.closest('#navMobile .mh10-menu-link') && typeof window.closeMobileMenu === 'function') window.closeMobileMenu();
  });
}());